module.exports = require('./helpers/bundle-url').getBundleURL('eOfb6') + "background.0e8c0738.png";